<template>
  <div>
    <b-card
no-body
class="mb-0"
>
      <div class="m-2">
        <b-tabs v-model="activeTab">
          <!-- ========== Ongoing Tab ========== -->
          <b-tab title="On Going">
            <b-row>
              <b-col
cols="12"
md="6"
class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
>
                <label>Show</label>
                <v-select
                  v-model="perPage"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
                />
                <label>entries</label>
              </b-col>
              <b-col
cols="12"
md="6"
>
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    v-model="searchQuery"
                    class="d-inline-block mr-1"
                    placeholder="Search..."
                  />
                  <b-button
v-if="createShow"
variant="primary"
@click="addNew"
>
                    <span class="text-nowrap">Add New Receive</span>
                  </b-button>
                </div>
              </b-col>
            </b-row>

            <b-table
              ref="refPurchaseOrderReceiveWarehouseTable"
              class="position-relative"
              :items="fetchPurchaseOrdersReceivesWarehouse"
              responsive
              :fields="tableColumns"
              primary-key="id"
              :sort-by.sync="sortBy"
              show-empty
              empty-text="No matching records found"
              :sort-desc.sync="isSortDirDesc"
            >
              <template #cell(WarehouseReceiveNumber)="data">
                <div class="text-nowrap">
                  {{ data.item.purchase_order_warehouse_receive_receiving_number || '-' }}
                </div>
              </template>

              <template #cell(PurchaseReceiveNumber)="data">
                <div class="text-nowrap">
                  {{ data.item.purchase_order_purchasing_receive ? data.item.purchase_order_purchasing_receive.purchase_order_purchasing_receive_receiving_number : '-' }}
                </div>
              </template>

              <template #cell(TotalReceived)="data">
                <div class="text-nowrap">
                  {{ data.item.purchase_order_warehouse_receive_total_received }}
                </div>
              </template>

              <template #cell(CreatedBy)="data">
                {{ data.item.user.user_fullname }}
              </template>

              <template #cell(DateCreated)="data">
                {{ dateSimple(
                      data.item.purchase_order_warehouse_receive_created_time,
                      "YYYY-MM-DD HH:mm:ss"
                    ) }}
              </template>

              <template #cell(Action)="data">
                <b-dropdown
variant="link"
no-caret
:right="$store.state.appConfig.isRTL"
>
                  <template #button-content>
                    <feather-icon
icon="MoreVerticalIcon"
size="16"
class="align-middle text-body"
/>
                  </template>
                  <b-dropdown-item @click="showDetail(data.item)">
                    <feather-icon icon="ZoomInIcon" />
                    <span class="align-middle ml-50">Details</span>
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="userRole === 'laboratory-manager' && data.item.purchase_order_warehouse_receive_confirmed_by_lab_manager==null"
                    @click="confirmPurchaseOrderByLabManager(data.item)"
                  >
                    <feather-icon icon="CheckIcon" />
                    <span class="align-middle ml-50">Confirm</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>

            <div class="mx-2 mb-2">
              <b-row>
                <b-col
cols="12"
sm="6"
class="d-flex align-items-center justify-content-center justify-content-sm-start"
>
                  <span
v-if="dataMeta"
class="text-muted"
>
                    Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries
                  </span>
                </b-col>
                <b-col
cols="12"
sm="6"
class="d-flex align-items-center justify-content-center justify-content-sm-end"
>
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalPurchaseOrder || (currentPage * perPage)"
                    :per-page="perPage"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon
icon="ChevronLeftIcon"
size="18"
/>
                    </template>
                    <template #next-text>
                      <feather-icon
icon="ChevronRightIcon"
size="18"
/>
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </b-tab>

          <!-- ========== Finished Tab ========== -->
          <b-tab title="Finished">
            <b-row>
              <b-col
cols="12"
md="6"
class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
>
                <label>Show</label>
                <v-select
                  v-model="perPageFinished"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
                />
                <label>entries</label>
              </b-col>
              <b-col
cols="12"
md="6"
>
                <div class="d-flex align-items-center justify-content-end">
                  <b-form-input
                    v-model="searchQueryFinished"
                    class="d-inline-block mr-1"
                    placeholder="Search..."
                  />
                </div>
              </b-col>
            </b-row>

            <b-table
              ref="refPurchaseOrderReceiveWarehouseTableFinished"
              class="position-relative"
              :items="fetchPurchaseOrdersReceivesWarehouseFinished"
              responsive
              :fields="tableColumns"
              primary-key="id"
              :sort-by.sync="sortByFinished"
              show-empty
              empty-text="No matching records found"
              :sort-desc.sync="isSortDirDesc"
            >
              <template #cell(WarehouseReceiveNumber)="data">
                <div class="text-nowrap">
                  {{ data.item.purchase_order_warehouse_receive_receiving_number || '-' }}
                </div>
              </template>

              <template #cell(PurchaseReceiveNumber)="data">
                <div class="text-nowrap">
                  {{ data.item.purchase_order_purchasing_receive ? data.item.purchase_order_purchasing_receive.purchase_order_purchasing_receive_receiving_number : '-' }}
                </div>
              </template>

              <template #cell(TotalReceived)="data">
                <div class="text-nowrap">
                  {{ data.item.purchase_order_warehouse_receive_total_received }}
                </div>
              </template>

              <template #cell(CreatedBy)="data">
                {{ data.item.user.user_fullname }}
              </template>

              <template #cell(DateCreated)="data">
                {{ dateSimple(
                      data.item.purchase_order_warehouse_receive_created_time,
                      "YYYY-MM-DD HH:mm:ss"
                    ) }}
              </template>

              <template #cell(Action)="data">
                <b-dropdown
variant="link"
no-caret
:right="$store.state.appConfig.isRTL"
>
                  <template #button-content>
                    <feather-icon
icon="MoreVerticalIcon"
size="16"
class="align-middle text-body"
/>
                  </template>
                  <b-dropdown-item @click="showDetail(data.item)">
                    <feather-icon icon="ZoomInIcon" />
                    <span class="align-middle ml-50">Detail</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>

            <div class="mx-2 mb-2">
              <b-row>
                <b-col
cols="12"
sm="6"
class="d-flex align-items-center justify-content-center justify-content-sm-start"
>
                  <span
v-if="dataMetaFinished"
class="text-muted"
>
                    Showing {{ dataMetaFinished.from }} to {{ dataMetaFinished.to }} of {{ dataMetaFinished.of }} entries
                  </span>
                </b-col>
                <b-col
cols="12"
sm="6"
class="d-flex align-items-center justify-content-center justify-content-sm-end"
>
                  <b-pagination
                    v-model="currentPageFinished"
                    :total-rows="totalPurchaseOrderFinished || (currentPageFinished * perPageFinished)"
                    :per-page="perPageFinished"
                    first-number
                    last-number
                    class="mb-0 mt-1 mt-sm-0"
                    prev-class="prev-item"
                    next-class="next-item"
                  >
                    <template #prev-text>
                      <feather-icon
icon="ChevronLeftIcon"
size="18"
/>
                    </template>
                    <template #next-text>
                      <feather-icon
icon="ChevronRightIcon"
size="18"
/>
                    </template>
                  </b-pagination>
                </b-col>
              </b-row>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BTabs, BTab,
  BDropdown, BDropdownItem, BPagination, BModal, VBModal, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import moment from 'moment-timezone'
import { ref, onUnmounted, getCurrentInstance } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import { VueHorizontalTimeline } from 'vue-horizontal-timeline'
import listPagePersistence from '@/mixins/listPagePersistence'
import PurchaseOrderReceiveWarehouse from './PreReceiveWarehouse'

export default {
  components: {
    BTabs,
    BTab,
    VueHorizontalTimeline,
    BListGroup,
    BListGroupItem,
    BModal,
    VBModal,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  mixins: [listPagePersistence(['currentPage', 'currentPageFinished', 'currentPageOngoing', 'activeTab'])],
  data() {
    return {
      activeTab: 0,
    }
  },
  setup() {
    const { proxy } = getCurrentInstance()
    const BRANCH_APP_STORE_MODULE_NAME = 'app-purchase-order'

    onUnmounted(() => {
      if (store.hasModule(BRANCH_APP_STORE_MODULE_NAME)) {
        store.unregisterModule(BRANCH_APP_STORE_MODULE_NAME)
      }
    })

    const userRole = ref(proxy.$cookies.get('UserRole') || '')
    const createShow = ref(true)
    const excludeRoleToCreate = ['laboratory-manager']

    if (excludeRoleToCreate.includes(userRole.value)) {
      createShow.value = false
    }

    const {
      fetchPurchaseOrdersReceivesWarehouse,
      fetchPurchaseOrdersReceivesWarehouseOngoing,
      fetchPurchaseOrdersReceivesWarehouseFinished,
      tableColumns,
      perPage,
      perPageOngoing,
      perPageFinished,
      currentPage,
      currentPageOngoing,
      currentPageFinished,
      totalPurchaseOrder,
      totalPurchaseOrderOngoing,
      totalPurchaseOrderFinished,
      dataMeta,
      dataMetaOngoing,
      dataMetaFinished,
      perPageOptions,
      searchQuery,
      searchQueryOngoing,
      searchQueryFinished,
      sortBy,
      isSortDirDesc,
      refPurchaseOrderReceiveWarehouseTable,
      refPurchaseOrderReceiveWarehouseTableOngoing,
      refPurchaseOrderReceiveWarehouseTableFinished,
      refetchData,
      sortByOngoing,
      sortByFinished,
      resolvePurchaseOrderRoleVariant,
      resolvePurchaseOrderRoleIcon,
      resolvePurchaseOrderStatusVariant,
      roleFilter,
      statusFilter,
    } = PurchaseOrderReceiveWarehouse()

    const dateSimple = (value, format = 'YYYY-MM-DD') => {
      if (!value) return null
      return moment.utc(value).tz('Asia/Jakarta').format(format)
    }

    const addNew = () => {
      proxy.$router.push({ name: 'apps-purchase-order-pre-receive-warehouse-new' })
    }

    const confirmPurchaseOrderByLabManager = data => {
      localStorage.setItem('PurchaseOrderWarehouseDetail', JSON.stringify(data))
      proxy.$router.push({ name: 'apps-purchase-order-warehouse-confirm' })
    }

    const showDetail = item => {
      localStorage.setItem('PurchaseOrderWarehouseDetail', JSON.stringify(item))
      proxy.$router.push({ name: 'apps-purchase-order-pre-receive-warehouse-detail' })
    }

    return {
      userRole,
      createShow,
      fetchPurchaseOrdersReceivesWarehouse,
      fetchPurchaseOrdersReceivesWarehouseOngoing,
      fetchPurchaseOrdersReceivesWarehouseFinished,
      tableColumns,
      perPage,
      perPageOngoing,
      perPageFinished,
      currentPage,
      currentPageOngoing,
      currentPageFinished,
      totalPurchaseOrder,
      totalPurchaseOrderOngoing,
      totalPurchaseOrderFinished,
      dataMeta,
      dataMetaOngoing,
      dataMetaFinished,
      perPageOptions,
      searchQuery,
      searchQueryOngoing,
      searchQueryFinished,
      sortBy,
      isSortDirDesc,
      refPurchaseOrderReceiveWarehouseTable,
      refPurchaseOrderReceiveWarehouseTableOngoing,
      refPurchaseOrderReceiveWarehouseTableFinished,
      refetchData,
      sortByOngoing,
      sortByFinished,
      resolvePurchaseOrderRoleVariant,
      resolvePurchaseOrderRoleIcon,
      resolvePurchaseOrderStatusVariant,
      roleFilter,
      statusFilter,
      avatarText,
      dateSimple,
      addNew,
      confirmPurchaseOrderByLabManager,
      showDetail,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
